// src/screens/Statistics.jsx

// THIS SCREEN IS NOT USED. MAYBE INTEGRATED LATER

import '../stylesheets/statistics_table.css';

import moment from 'moment/moment';
import React from 'react';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { CSVDownload, CSVLink } from 'react-csv';
import { withTranslation } from 'react-i18next';

import { getMyAccountData } from '../actions/account';
import { getStatistics } from '../actions/statistics';
import FormInput from '../components/FormInput';
import globalStyles from '../stylesheets/globalStyles';

const arrow_up = '&#8595;';
const arrow_down = '&#8593;';

const i18nPrefix = 'Statistics';

class Statistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      from_date: moment().startOf('year'),
      to_date: moment().endOf('year'),
      rows: [],
      sort_key: 'ID',
      sort_direction: 'ASC',
      account: {},
    };
    this.csvLink = React.createRef();
  }

  componentDidMount() {
    getMyAccountData(
      (account) => this.setState({ account: account }),
      () => {},
    );
    this.load();
  }

  exportToCSVClicked = () => {
    this.csvLink.link.click();
  };

  itterateDirection = (direction) => {
    if (direction === 'ASC') return 'DSC';
    if (direction === 'DSC') return '';
    if (direction === '') return 'ASC';
    return 'ASC';
  };

  changeSortDirections = (sort_key) => {
    let sort_direction = '';
    if (this.state.sort_key === sort_key) {
      sort_direction = this.itterateDirection(this.state.sort_direction);
    } else {
      sort_direction = 'ASC';
    }
    this.setState({ sort_key, sort_direction });
  };

  // sorting client-side to mimic example behavior
  getSortedRows = (rows) => {
    const { sort_key, sort_direction } = this.state;
    if (!sort_key || sort_direction === '') return rows;
    const copy = [...rows];
    copy.sort((a, b) => {
      const av = a?.[sort_key];
      const bv = b?.[sort_key];
      let cmp = 0;
      if (typeof av === 'number' && typeof bv === 'number') {
        cmp = av - bv;
      } else {
        cmp = String(av ?? '').localeCompare(String(bv ?? ''), undefined, {
          numeric: true,
        });
      }
      return sort_direction === 'DSC' ? -cmp : cmp;
    });
    return copy;
  };

  load = () => {
    const from_date = moment(this.state.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.state.to_date).format('YYYY-MM-DD');
    this.setState({ loading: true, error: null }, () => {
      getStatistics(
        from_date,
        to_date,
        (rows) =>
          this.setState({
            rows: Array.isArray(rows?.rows) ? rows.rows : rows,
            loading: false,
          }),
        (err) =>
          this.setState({ loading: false, error: err?.message || 'Error' }),
      );
    });
  };

  render() {
    const { t } = this.props;
    const arrow =
      this.state.sort_direction === ''
        ? ''
        : this.state.sort_direction === 'ASC'
          ? arrow_up
          : arrow_down;

    const rows = this.getSortedRows(this.state.rows);

    return (
      <Container className='statistics-table' sm={12}>
        <Row>
          <Col sm={4}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {t(`${i18nPrefix}.title`)}
              {this.state.loading && (
                <Spinner
                  style={{
                    width: 25,
                    height: 25,
                    marginLeft: 10,
                    borderWidth: '0.1em',
                  }}
                  animation='border'
                  variant='secondary'
                  role='status'
                />
              )}
            </h2>
          </Col>

          <Col sm={8}>
            <Button
              style={{
                ...globalStyles.saveButton,
                marginLeft: 10,
              }}
              disabled={this.state.loading}
              onClick={() => this.exportToCSVClicked()}>
              {t(`global.export`)}
            </Button>

            <CSVLink
              separator={this.state.account.csv_separator}
              style={{ visibility: 'hidden' }}
              ref={(ref) => (this.csvLink = ref)}
              filename='BP-statistics.csv'
              data={this.state.rows}>
              Download me
            </CSVLink>
          </Col>
        </Row>

        <Row className='mb-3'>
          <Col md={3}>
            <FormInput
              label={t ? t('global.from') : 'From'}
              type='date'
              required
              value={moment(this.state.from_date).format('YYYY-MM-DD')}
              onChange={(e) => {
                const from_date = moment(e.target.value);
                let to_date = this.state.to_date;
                if (from_date.isAfter(to_date))
                  to_date = moment(from_date).add(1, 'day');
                this.setState({ from_date, to_date }, this.load);
              }}
            />
          </Col>
          <Col md={3}>
            <FormInput
              label={t ? t('global.to') : 'To'}
              type='date'
              required
              value={moment(this.state.to_date).format('YYYY-MM-DD')}
              min={moment(this.state.from_date)
                .add(1, 'day')
                .format('YYYY-MM-DD')}
              onChange={(e) => {
                this.setState({ to_date: moment(e.target.value) }, this.load);
              }}
            />
          </Col>
        </Row>

        {this.state.error && (
          <div className='text-danger' style={{ marginBottom: 12 }}>
            {this.state.error}
          </div>
        )}

        <div className='view'>
          <div className='wrapper t-container' id='statistics_table_div'>
            <table className='table'>
              <thead>
                <tr>
                  {[
                    'ID',
                    'Buchung',
                    'Marina-Account',
                    'Gast ID',
                    'Gast eMail',
                    'Platz ID',
                    'Hafen',
                    'Platz Nr.',
                    'Von',
                    'Bis',
                    'Jahr',
                    'Abrechnungs-Monat',
                    'Monat',
                    'Dauer',
                    'Rate',
                    'Buchungspreis',
                    'Taxen',
                    'Total',
                    'Währung',
                    'Storniert',
                    'Stornierungstyp',
                    'Rückerstattung Buchungspreis',
                    'Total Rückerstattung Taxen',
                    'Total Rückerstattung',
                    'Transaktions-Preis',
                    'Provision',
                    'Auszahlung',
                    'Max. Länge',
                    'Max. Breite',
                    'Platz - Typ',
                    'Platz - Zone/Kat.',
                    'Platz verwaltet durch',
                    'Bemerkungen',
                    'Wert Eigenbuchung',
                    'Day – by - Day',
                    'Check - In nicht freigegebener Platz',
                  ].map((key, i) => (
                    <th
                      key={key}
                      className={i === 0 ? 'first-col sticky-col' : ''}
                      onClick={() => this.changeSortDirections(key)}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: `${key} ${this.state.sort_key === key ? arrow : ''}`,
                        }}
                      />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((r, idx) => (
                  <tr key={idx} style={{ cursor: 'default' }}>
                    <td className='first-col sticky-col'>
                      {r['ID'] ?? idx + 1}
                    </td>
                    <td>{r['Buchung']}</td>
                    <td>{r['Marina-Account']}</td>
                    <td>{r['Gast ID']}</td>
                    <td>{r['Gast eMail']}</td>
                    <td>{r['Platz ID']}</td>
                    <td>{r['Hafen']}</td>
                    <td>{r['Platz Nr.']}</td>
                    <td>{r['Von']}</td>
                    <td>{r['Bis']}</td>
                    <td>{r['Jahr']}</td>
                    <td>{r['Abrechnungs-Monat']}</td>
                    <td>{r['Monat']}</td>
                    <td>{r['Dauer']}</td>
                    <td>{r['Rate']}</td>
                    <td>{r['Buchungspreis']}</td>
                    <td>{r['Taxen']}</td>
                    <td>{r['Total']}</td>
                    <td>{r['Währung']}</td>
                    <td>{r['Storniert']}</td>
                    <td>{r['Stornierungstyp']}</td>
                    <td>{r['Rückerstattung Buchungspreis']}</td>
                    <td>{r['Total Rückerstattung Taxen']}</td>
                    <td>{r['Total Rückerstattung']}</td>
                    <td>{r['Transaktions-Preis']}</td>
                    <td>{r['Provision']}</td>
                    <td>{r['Auszahlung']}</td>
                    <td>{r['Max. Länge']}</td>
                    <td>{r['Max. Breite']}</td>
                    <td>{r['Platz - Typ']}</td>
                    <td>{r['Platz - Zone/Kat.']}</td>
                    <td>{r['Platz verwaltet durch']}</td>
                    <td>{r['Bemerkungen']}</td>
                    <td>{r['Wert Eigenbuchung']}</td>
                    <td>{r['Day – by - Day']}</td>
                    <td>{r['Check - In nicht freigegebener Platz']}</td>
                  </tr>
                ))}
                {!this.state.loading && rows.length === 0 && (
                  <tr>
                    <td colSpan={36} className='text-center'>
                      {t(`${i18nPrefix}.noData`)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    );
  }
}

export default withTranslation()(Statistics);
